import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import DealerList from './DealerList';

const DealerListPage = () => {
    const { t } = useTranslation(['dealerList']);

    const goToNewDealerPage = useGoTo('/admin/dealers/add');
    const { permissions: accountPermissions } = useAccount();

    const extra = hasPermissions(accountPermissions, [permissionKind.createDealer]) ? (
        <Button icon={<PlusOutlined />} onClick={goToNewDealerPage} type="primary">
            {t('dealerList:actions.addDealer')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('dealerList:title')}>
            <DealerList />
        </ConsolePageWithHeader>
    );
};

export default DealerListPage;
